import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M23.75 41.5625V37.6042H37.6042V9.89583H23.75V5.9375H37.6042C38.6927 5.9375 39.6246 6.32509 40.3997 7.10026C41.1749 7.87543 41.5625 8.80729 41.5625 9.89583V37.6042C41.5625 38.6927 41.1749 39.6246 40.3997 40.3997C39.6246 41.1749 38.6927 41.5625 37.6042 41.5625H23.75ZM19.7917 33.6458L17.0703 30.776L22.1172 25.7292H5.9375V21.7708H22.1172L17.0703 16.724L19.7917 13.8542L29.6875 23.75L19.7917 33.6458Z",
		fill: "url(#paint0_linear_29146_1332)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_29146_1332",
		x1: 5.75005,
		y1: 42.0313,
		x2: 47.7645,
		y2: 14.7219,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedLogout;
